export default [
  {
    label: 'メールアドレス',
    key: 'search_mail',
  },
  {
    label: 'デバイス名',
    key: 'search_devicename',
  },
  {
    label: 'Macアドレス',
    key: 'search_mac',
  },
]
